import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Reflexoes from "@/pages/Reflexoes";
import ReflexaoDetail from "@/pages/ReflexaoDetail";
import Produtos from "@/pages/Produtos";
import Contato from "@/pages/Contato";
import Links from "@/pages/Links";
import Login from "@/pages/Login";
import Comunidade from "@/pages/Comunidade";
import RecuperarSenha from "@/pages/RecuperarSenha";
import RedefinirSenha from "@/pages/RedefinirSenha";
import Admin from "@/pages/Admin";

function Protected({ children, admin = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]" data-testid="auth-loading">
        <span className="font-serif tracking-[0.3em] text-gold">REFLLEXIVE</span>
      </div>
    );
  if (!user) return <Navigate to="/entrar" state={{ from: location.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/reflexoes" element={<Layout><Reflexoes /></Layout>} />
              <Route path="/reflexoes/:slug" element={<Layout><ReflexaoDetail /></Layout>} />
              <Route path="/produtos" element={<Layout><Produtos /></Layout>} />
              <Route path="/contato" element={<Layout><Contato /></Layout>} />
              <Route path="/links" element={<Links />} />
              <Route path="/entrar" element={<Login />} />
              <Route path="/recuperar-senha" element={<RecuperarSenha />} />
              <Route path="/redefinir-senha" element={<RedefinirSenha />} />
              <Route path="/comunidade" element={<Protected><Layout><Comunidade /></Layout></Protected>} />
              <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0a0a0a", border: "1px solid rgba(212,175,55,0.3)", color: "#f5f5f5" } }} />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
